import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import React from 'react'
import Image from 'next/image'

export function CustomizedMessage(props: any): React.ReactElement {
  return (
    <div className={'mb-1 mr-12 flex items-end gap-2.5'}>
      <div className={'relative h-7 w-7 shrink-0 rounded-full'}>
        <Image
          src={
            props?.message?.sender?.plainProfileUrl ??
            process.env.NEXT_PUBLIC_DEFAULT_AVATAR_URL!
          }
          className={'rounded-full object-cover'}
          fill={true}
          alt={'User avatar'}
        />
      </div>

      <div className={'flex flex-col'}>
        <div className={'text-caption-normal ml-2 text-darul-300'}>
          {props?.message?.sender?.nickname ?? ''}
        </div>

        <div className={'mt-0.5 inline-block rounded-lg bg-fizz-600 px-4 pb-3'}>
          <ReactMarkdown
            remarkPlugins={[remarkBreaks]}
            className={'chat-markdown font-sans text-sm font-light text-white'}
            linkTarget={'_blank'}
          >
            {props?.message?.message ?? ''}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  )
}
